import React from 'react'
import { graphql } from 'gatsby'

import QuoteSectionComponent from '../components/QuoteSection'

const QuoteSection = ({ slice }) => {
  const { primary, items } = slice
  const person = primary?.person?.document?.data
  return (
    <section className={`section quote-section`}>
      <div className="container">
        <QuoteSectionComponent
          quote={person?.quote?.text}
          authorAvatar={person?.photo}
          authorName={person?.name}
          authorPosition={person?.position}
          buttonText={primary?.more_button_title?.text}
          buttonLink={primary?.more_button_link}
          buttonTheme={primary?.link_theme}
          backgroundImage={primary.background_image}
        />
      </div>
    </section>
  )
}

export default QuoteSection

export const query = graphql`
  fragment PageDataBodyQuote on PrismicPageDataBodyQuote {
    id
    primary {
      person {
        document {
          ... on PrismicPerson {
            id
            data {
              photo {
                gatsbyImageData
                alt
              }
              name
              position
              quote {
                text
              }
            }
          }
        }
      }
      background_image {
        gatsbyImageData
        alt
      }
      link_theme
      more_button_link {
        url
        target
      }
      more_button_title {
        text
      }
    }
  }
  fragment SolutionsDataBodyQuote on PrismicSolutionsDataBodyQuoteSection {
    id
    primary {
      person {
        document {
          ... on PrismicPerson {
            id
            data {
              photo {
                gatsbyImageData
                alt
              }
              name
              position
              quote {
                text
              }
            }
          }
        }
      }
      background_image {
        gatsbyImageData
        alt
      }
      link_theme
      more_button_link {
        url
        target
      }
      more_button_title {
        text
      }
    }
  }
  fragment TechnologyPageTemplateDataBodyQuoteSection on PrismicTechnologyPageTemplateDataBodyQuoteSection {
    id
    primary {
      person {
        document {
          ... on PrismicPerson {
            id
            data {
              photo {
                gatsbyImageData
                alt
              }
              name
              position
              quote {
                text
              }
            }
          }
        }
      }
      background_image {
        gatsbyImageData
        alt
      }
      link_theme
      more_button_link {
        url
        target
      }
      more_button_title {
        text
      }
    }
  }
`
